module.exports = __webpack_public_path__ + "img/oopsLeft.2ccb8443.svg";